import { Print } from "./print";

export enum ProductType {
  starmap = "starmap",
  soundwave = "soundwave",
  baby = "baby",
}

export enum PrintType {
  poster = "poster",
  posterFramed = "poster-framed",
  digital = "digital",
  metalPrint = "metal-print",
  galleryPrint = "gallery-print",
  poster30x40cm = "poster_30x40cm",
  posterFramed30x40cm = "poster-framed_30x40cm"
}

export enum InterfaceLanguage {
  en = "en",
  de = "de",
  fr = "fr",
  es = "es",
  it = "it",
}

export interface Product {
  type: ProductType;
  productProperties?: any;
  productId?: any;
}

export interface PrintProduct {
  product: Product;
  print: Print;
  price: number;
  images?: string[];
  isDevelopmentProduct: boolean;
}

export interface LineItem extends PrintProduct {
  customerInfo: { [key: string]: string };
  discountPercent: number;
  priceInUserCurrency: number;
}
export interface Cart {
  deliveryExpectation?: string;
  madeIn?: string;
  lineItems: LineItem[];
  productType: ProductType;
  isEmpty: boolean;
  deliveryHighlighting: string;
}

export function isProduct(product: any): product is ProductType {
  return Object.values(ProductType).includes(product);
}

export function isInterfaceLanguage(lang: any): lang is InterfaceLanguage {
  return Object.values(InterfaceLanguage).includes(lang);
}

export interface PutRequestBody {
  product: {
    type: ProductType;
  };
  print: {
    type: PrintType;
    printProperties?: any;
  };
  replaceId?: string;
}
